import React from 'react';
import { useSelector } from 'react-redux';
import { T } from 'shared/helper/translate';
import { getChinaLocalization } from 'shared/account/reducer';
import featureEnabled from 'shared/helper/feature';
import { getIsPastDue, getPaddlePlanIdForCurrentPlan } from '../reducer';
import PlanManagementButton from '../plan/PlanManagementButton';

/**
 * PaymentRecoveryBanner
 *
 * Shown on the workspace (editing/translation tabs) when a user is in the
 * payment recovery grace period (premium.status === 'error' and NOT trial-blocked).
 *
 * This is entirely additive — it renders nothing unless isPastDue is true.
 * It does not alter or suppress any existing banner logic.
 */
var PaymentRecoveryBanner = function PaymentRecoveryBanner() {
  var isPastDue = useSelector(getIsPastDue);
  var curiePlan = useSelector(function (_ref) {
    var curie = _ref.curie;
    return curie.plan;
  });
  var paddlePlanId = useSelector(getPaddlePlanIdForCurrentPlan);
  var isChinaUser = useSelector(getChinaLocalization);
  var paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');
  var useCartInsteadOfPaddle = isChinaUser && !paddleBillingForChina;

  // Only show for Paddle users in the grace period. China cart users are unaffected.
  if (!isPastDue || useCartInsteadOfPaddle) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "row mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-block alert-warning"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "curie.payment-recovery-banner",
    linkRenderer: function linkRenderer(_ref2) {
      var _curiePlan$paddleSubs;
      var children = _ref2.children;
      return /*#__PURE__*/React.createElement(PlanManagementButton, {
        classicUrl: (_curiePlan$paddleSubs = curiePlan.paddleSubscription) === null || _curiePlan$paddleSubs === void 0 ? void 0 : _curiePlan$paddleSubs.updateUrl,
        targetAction: "update",
        paddlePlanId: paddlePlanId,
        asButton: false
      }, children);
    }
  })))));
};
export default PaymentRecoveryBanner;